import { useCallback } from "react";
import { useLocale, useLocaleStore } from "@/lib/locale";

export const useTranslation = () => {
  const t = useLocale();
  const setCurrentLanguage = useLocaleStore(
    (state) => state.setCurrentLanguage,
  );
  // Subscribe to currentLanguage changes to trigger re-renders
  const currentLanguage = useLocaleStore((state) => state.currentLanguage);

  const changeLanguage = useCallback(
    (language: string) => {
      setCurrentLanguage(language);
    },
    [setCurrentLanguage],
  );

  const processPlaceholders = (
    text: string,
    params?: Record<string, string | number>,
  ) => {
    if (!params || typeof text !== "string") return text;

    let processedText = text;
    Object.keys(params).forEach((key) => {
      const value = String(params[key]);
      processedText = processedText.replaceAll(`\${${key}}`, value);
      processedText = processedText.replaceAll(`{{${key}}}`, value);
    });

    return processedText;
  };

  return {
    t: (
      key: string,
      fallback?: string,
      params?: Record<string, string | number>,
    ) => {
      const translation = t(key, fallback);
      return processPlaceholders(translation, params);
    },
    language: currentLanguage,
    changeLanguage,
  };
};
